import React from 'react';
import config from '../config';


function NotFoundPage() {
  return (
    <section className="error-page">
      <div className="container">
        <div className="row">
          <div className="col-xl-6 col-lg-6">
            <div className="error-page__left">
              <h2 className="error-page__title">404</h2>
              <h3 className="error-page__tagline">Oops! Page Not Found</h3>
              <p className="error-page__text">The page you are looking for is not exist.</p>
              <form className="error-page__form">
                <div className="error-page__form-input">
                </div>
              </form>
              <div className="error-page__btn-box">
                <a href="/" className="thm-btn error-page__btn">
                  Back to Home
                </a>
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-lg-6">
            <div className="error-page__right">
              <div className="error-page__img img-bounce">
              <img src={`${config.baseUrl}/assets/images/resources/error-page-img-1.png`} alt="Error illustration" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default NotFoundPage;